import {
  StripeElementLocale,
  StripeElementsOptions,
  StripePaymentElementOptions,
} from '@stripe/stripe-js';

import {
  IGetStripeElementsOptions,
  IMollieCreateComponentOptions,
  IMolliePaymentMethodCode,
} from '@src/interfaces/payments.interfaces';

import { COLORS } from './styles.constants';

export const MOLLIE_MODULE_SRC = 'https://js.mollie.com/v1/mollie.js';
export const TRIVIAL_DEFAULT_FIRST_PERIOD_DAYS = 7;
export const DEFAULT_CURRENCY = 'EUR';
export const SCRATCH_DISCOUNT_PERCENT = 70;
export const FINAL_PROMO_CODE_SUFFIX = '_final';
export const TIMER_DIGIT_ANIMATION_DURATION = 0.3;
export const PRICE_DROP_ANIMATION_DURATION = 0.4;
export const DISCOUNT_BADGE_ANIMATION_DURATION = 0.25;

export const PAYMENT_MODAL_BODY_ID = 'Payment-Modal';

export const PAYPAL_SVG_IMAGE =
  ' https://cdn.prod.website-files.com/64a8ed37a4d8d06ce50b5b1d/68c934ed35c8d58956952b95_icon-pm-paypal.svg';

export const TRACKING_DOMAINS = ['go.fitfast.com'];

export const GATEWAYS = {
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  STRIPE: 'stripe',
  MOLLIE: 'mollie',
  PRIMER: 'primer',
} as const;

export const MOLLIE_PAYMENT_METHOD_CODES = {
  APPLE_PAY: 'applepay',
  IDEAL: 'ideal',
  PAYPAL: 'paypal',
  BAN_CONTACT: 'bancontact',
  CREDIT_CARD: 'creditcard',
} as const;

export const PRIMER_PAYMENT_METHOD_CODES = {
  CREDIT_CARD: 'creditcard',
} as const;

export const MOLLIE_PAYMENT_METHODS_ORDER: IMolliePaymentMethodCode[] = [
  MOLLIE_PAYMENT_METHOD_CODES.PAYPAL,
  MOLLIE_PAYMENT_METHOD_CODES.IDEAL,
  MOLLIE_PAYMENT_METHOD_CODES.PAYPAL,
  MOLLIE_PAYMENT_METHOD_CODES.BAN_CONTACT,
  MOLLIE_PAYMENT_METHOD_CODES.CREDIT_CARD,
];

export const PAYMENT_INTENT_STATUSES = {
  CREATED: 'created',
  SUCCESS: 'success',
  CANCELLED: 'canceled',
  REFUNDED: 'refunded',
} as const;

export const PAYMENT_REDIRECT_STATUS = {
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

export const STRIPE_PAYMENT_ELEMENT_OPTIONS: StripePaymentElementOptions = {
  layout: {
    type: 'tabs',
    defaultCollapsed: false,
  },
  paymentMethodOrder: ['blik', 'card', 'paypal'],
  terms: {
    card: 'never',
    paypal: 'never',
    applePay: 'never',
    googlePay: 'never',
  },
  fields: {
    billingDetails: {
      address: {
        country: 'never',
        postalCode: 'never',
      },
    },
  },
};

export const getStripeElementsOptions = ({
  language,
  clientSecret,
}: IGetStripeElementsOptions): StripeElementsOptions => ({
  appearance: {
    theme: 'flat',
    variables: {
      colorPrimary: COLORS['blue-1'],
    },
  },
  locale: language as StripeElementLocale,
  clientSecret,
});

export const MOLLIE_OPTIONS: IMollieCreateComponentOptions = {
  styles: {
    base: {
      fontSize: '18px',
      color: COLORS['blue-24'],
    },
  },
};

export const PAYPAL_MOLLY_PAYMENT_METHOD = {
  code: MOLLIE_PAYMENT_METHOD_CODES.PAYPAL,
  description: 'Paypal',
  image: {
    size1x: '',
    size2x: '',
    svg: PAYPAL_SVG_IMAGE,
  },
  isCardMethod: false,
  isAppleMethod: false,
  isPaypalMethod: true,
};
